var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.21997 0 5.47991 0.52784 3.99987 1.51677C2.51983 2.5057 1.36628 3.91131 0.685088 5.55585C0.00389948 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32386 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0ZM13.6694 7.12391L7.94209 12.8512C7.78866 13.0046 7.58059 13.0907 7.36364 13.0907C7.14669 13.0907 6.93862 13.0046 6.78518 12.8512L4.33064 10.3966C4.1816 10.2423 4.09913 10.0356 4.101 9.82112C4.10286 9.6066 4.18891 9.40139 4.34061 9.24969C4.4923 9.09799 4.69751 9.01194 4.91204 9.01008C5.12656 9.00822 5.33324 9.09068 5.48755 9.23972L7.36364 11.1158L12.5125 5.967C12.6668 5.81796 12.8734 5.73549 13.088 5.73736C13.3025 5.73922 13.5077 5.82527 13.6594 5.97696C13.8111 6.12866 13.8971 6.33387 13.899 6.5484C13.9009 6.76292 13.8184 6.96959 13.6694 7.12391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selectedIcon.5d1dda1b660a1162efffd2cd62de54b6.svg";
export { ForwardRef as ReactComponent };